export default __webpack_public_path__ + "static/media/logo_coa.d691824b.png";